import { ISorter } from "@/models/tables";
import { CreatedAtSorter } from "@/data/sorters/object";

export const DefaultSorters: () => ISorter[] = () => [CreatedAtSorter()];
